import { HOMEPAGE_PAGE_KEY } from '@/views/Homepage/constants';

const es = {
  [HOMEPAGE_PAGE_KEY]: {
    SEO_TITLE: 'Desarrollamos talento en tu empresa',
    SEO_DESCRIPTION:
      'Somos la plataforma All-in-One para cada uno de tus retos de gestión humana.',

    SEO_CATEGORIES_TITLE: 'Categorías',
    SEO_SUBCATEGORIES_TITLE: 'Subcategorías',
    SEO_SOFTWARES_TITLE: 'Softwares',
    SEO_TRACKS_TITLE: 'Especializaciones',
    SEO_SEE_MORE: 'Ver más',
    SEO_SEE_LESS: 'Ver menos',

    HERO_TITLE: 'Desarrollamos talento en tu empresa',
    HERO_SUBTITLE:
      'En Crehana, ahora también potenciamos equipos a través de soluciones de aprendizaje y gestión de talento',
    HERO_CTA: 'Empezar ahora',
    HERO_CTA_VARIANT: 'Solicitar Demo',
    HERO_LINK: 'Hablar con un asesor',

    COMPANIES_LOGOS_TITLE: '+1000 empresas',
    COMPANIES_LOGOS_SUBTITLE: 'Que confian en nosotros',

    BANNER_TITLE:
      '¿Lo mejor? Puedes elegir todas, o las que más se adapten a lo que hoy necesitas.',
    BANNER_LINK: 'Quiero saber más',

    PREFOOTER_TITLE: 'Empieza a construir equipos más competitivos hoy ',
    PREFOOTER_SUBTITLE:
      'Prueba durante 7 días nuestra plataforma de gestión de aprendizaje.',
    PREFOOTER_CTA: 'Empezar ahora',
    PREFOOTER_LINK: 'Hablar con un asesor',

    PRODUCT_TAB1: 'E-Learning',
    PRODUCT_TAB2: 'LMS Elevate',
    PRODUCT_TAB3: 'Gestión de Talento',
    PRODUCT_TAB4: 'Data y reportes en tiempo real',

    PRODUCT_TITLE1: 'La plataforma',
    PRODUCT_TITLE2: 'All-in-One',
    PRODUCT_TITLE3: 'para cada uno de tus retos de gestión humana',

    PRODUCT_TAB1_TITLE: 'E-Learning',
    PRODUCT_TAB1_DESCRIPTION:
      'Prepara a tu equipo para retos actuales y futuros, potenciando sus habilidades actuales y desarrollando su talento para destacar en sus roles.',
    PRODUCT_TAB1_CARD1:
      '+1000 cursos online con la mejor producción audiovisual de Latam.',
    PRODUCT_TAB1_CARD2:
      '+20 Academias en los temas más demandados por el mercado laboral.',
    PRODUCT_TAB1_CARD3:
      'Ventas, Marketing, Data Analytics, Liderazgo, Soft Skills, y mucho más.',
    PRODUCT_TAB1_CARD4: 'Mentoría personalizada.',
    PRODUCT_TAB1_CARD5:
      'Profesionales de empresas líderes que enseñan desde su experiencia.',
    PRODUCT_TAB2_TITLE: 'LMS Elevate',
    PRODUCT_TAB2_DESCRIPTION:
      'Con nuestro LMS, olvídate de gestionar diferentes plataformas, y maneja todos tus recursos de aprendizaje y desarrollo de talento en un solo lugar. Facilita la experiencia de tu equipo, y haz tu trabajo más sencillo',
    PRODUCT_TAB2_CARD1:
      '¿Tu compañía tiene cursos propios? ¡Súbelos a tu panel en Crehana!',
    PRODUCT_TAB2_CARD2: 'Crea y agenda sesiones en vivo.',
    PRODUCT_TAB2_CARD3:
      'Diseña evaluaciones para medir el aprendizaje de tu equipo.',
    PRODUCT_TAB2_CARD4:
      'Integra a tus propios proveedores, así, tú equipo podrá ver sus contenidos desde una sola plataforma.',
    PRODUCT_TAB3_TITLE: 'Gestión de Talento',
    PRODUCT_TAB3_DESCRIPTION:
      'Agiliza la manera de medir el employee engagement y performance, analiza tu cultura organizacional y crea planes para fortalecerla.',
    PRODUCT_TAB3_CARD1:
      'Objetivos: Gestiona los KPI’s y OKR’s de cada persona sin complicaciones.',
    PRODUCT_TAB3_CARD2:
      'Reconocimiento y Feedback: Incentiva una cultura de reconocimiento y retroalimentación constante.',
    PRODUCT_TAB3_CARD3:
      'Clima laboral: Identifica la satisfacción de tus equipos y crea planes para su bienestar y retención.',
    PRODUCT_TAB4_TITLE: 'Data y reportes en tiempo real',
    PRODUCT_TAB4_DESCRIPTION:
      'Lo que no se mide, no se puede mejorar. Apoya tu estrategia con reportes en tiempo real con métricas y datos clave del talento en tu empresa.',
    PRODUCT_TAB4_CARD1:
      'Mide las habilidades actuales de los equipos con el Skill XP y comprende qué necesitan para crecer.',
    PRODUCT_TAB4_CARD2: 'Métricas claras, fáciles de entender y analizar.',
    PRODUCT_TAB4_CARD3: 'Reportes en tiempo real que puedes descargar.',
    PRODUCT_TAB4_CARD4: 'Comparte los resultados relevantes con otros líderes.',

    COMPANIES_TITLE1: '+1000 compañías',
    COMPANIES_TITLE2: 'desarrollan su talento con nosotros',

    LEADERS_TITLE: 'Líderes en Latam recomiendan Crehana',
    LEADERS_ROLE1: 'Coordinadora de Aprendizaje en Entel Perú.',
    LEADERS_ROLE2:
      'Directora Regional de Talento Humano en SURA Asset Management',
    LEADERS_ROLE3: 'HR Manager en Bioderma.',

    LEADERS_STORY1:
      'Nuestra experiencia con Crehana fue excelente. No solo por el contenido de la plataforma, también por el contacto y la flexibilidad que nos dieron para utilizar las licencias. Los cursos me gustaron mucho, el tiempo de cada parte fue perfecto y siento que los ejemplos y las explicaciones fueron muy buenas. La plataforma es amigable, fácil de usar e intuitiva.',
    LEADERS_STORY2:
      'Las clases de Crehana me cambiaron la perspectiva del microaprendizaje, más bien la llamaría fragmentación visualmente ergonómica del conocimiento. Fácilmente puedes escuchar 50 minutos sin que los sientas.',
    LEADERS_STORY3:
      'Estamos muy agradecidos con la oportunidad, nuestros colaboradores la han recibido con mucho entusiasmo y motivación ya que los temas son muy buenos, actuales y aportan mucho al desarrollo de nuestra gente. Desde el punto de vista de HR, Crehana es un aliado estratégico para armar planes de desarrollo y capacitación, retención de talentos y reconocimientos e incentivos',

    WHY_CREHANA_TITLE: '¿Por qué Crehana?',

    WHY_CREHANA_CARD_TITLE_1:
      'Diseñamos nuestra plataforma para que disfrutes usarla',
    WHY_CREHANA_CARD_DESCRIPTION_1:
      'Sabemos que una buena experiencia depende de su facilidad de uso y de un buen diseño. ¡Tenemos ambos!',
    WHY_CREHANA_CARD_TITLE_2:
      'Creamos soluciones pensando en lo que tú necesitas',
    WHY_CREHANA_CARD_DESCRIPTION_2:
      'Te acompañamos en cada etapa, escuchamos, entendemos, y afrontamos los retos que vengan con soluciones pensadas en lo que tus equipos necesitan.',
    WHY_CREHANA_CARD_TITLE_3: 'Nuestros equipos están realmente cerca de ti',
    WHY_CREHANA_CARD_DESCRIPTION_3:
      'Crehana nace en LatAm, con equipos en México, Perú, Colombia, Brasil y +8 países, con personas que hablan en tu idioma y entienden tus retos más fácilmente.',
    WHY_CREHANA_CARD_TITLE_4:
      'Llevamos +7 años desarrollando a +6M de personas',
    WHY_CREHANA_CARD_DESCRIPTION_4:
      'Más del 81% de personas que aprenden con nosotros lo aplican en sus trabajos. Ayudamos a personas y compañías en Latam a lograr sus metas y objetivos.',

    VIDEO_SECTION_TITLE: '¿Qué es Crehana?',
    VIDEO_SECTION_VIDEO_OVERLAY_TEXT: 'Conoce Crehana en 1 minuto',
  },
};

export default es;
